module.exports = __webpack_public_path__ + "static/blog77-8b5efda394b69d584656e630c8982db0.png";